export default "__VITE_PUBLIC_ASSET__c7ac77cb__"